import { Injectable } from '@angular/core';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor() {}
  public static isLive(startDate: any, startTime: any, endTime: any,  serverTime: any): boolean {
    if (moment(startDate).isSame(moment(serverTime), 'day')) {
      return moment(serverTime).isBetween(startTime, endTime);
    } else {
      return false;
    }
  }

  public static classType(
    serverTime: any,
    startTime: any,
    endTime: any,
    mettingStatus: string = ''
  ) {
    let type = 'upcoming';
    //
    // console.log(moment.unix(endTime));

    var servTime = moment.unix(serverTime);
    var sTime = moment.unix(startTime);
    var eTime = moment.unix(endTime);

    var duration = moment.duration(sTime.diff(servTime));
    var diff = duration.asMilliseconds();
    var endDuration = moment.duration(eTime.diff(servTime));
    var enddiff = endDuration.asMilliseconds();
    if (diff < 0 && enddiff > 0 && mettingStatus != 'ended') {
      type = 'ongoing';
    } else if (enddiff < 0 || mettingStatus == 'ended') {
      type = 'past';
    } else {
      type = 'upcoming';
    }

    return type;
  }

  public static getTime(etime: any, serverTime?: any, stime?: any) {
    // var servTime = moment.unix(serverTime);

    etime = moment(etime);
    stime = moment(stime);
    let now = moment.unix(serverTime);
    // var x = etime.diff(now) > 0? etime.diff(now) : 0
    var x = etime.diff(stime) > 0 ? etime.diff(stime) : 0;
    var start = stime.diff(now) > 0 ? stime.diff(now) : 0;
    if (start == 0) {
      x = etime.diff(now) > 0 ? etime.diff(now) : 0;
    }
    let tempTime: any = moment.duration(x);
    // tempTime.minutes();
    let min = Math.floor((tempTime._milliseconds / 1000 / 60) << 0);
    let sec = Math.floor((tempTime._milliseconds / 1000) % 60);
    let onlySec = Math.floor(tempTime._milliseconds / 1000);
    return { time: onlySec, start: start };
  }

  public static getTimePassed(endTime: number, serverTime: any) {
    const collapsedTime = moment(endTime);
    const now = moment(serverTime);
    const timeDifference: any = moment.duration(now.diff(collapsedTime));
    return Math.floor(timeDifference._milliseconds / 1000);
  }

  public static isTomorrow(startDate: any, serverTime: any) {
    let now = moment(serverTime);
    let tma = moment(startDate).format('L') == now.add(1, 'days').format('L');
    return tma;
  }

  public static isUpcomming(startDate: any, serverTime: any) {
    let _wd = this.getWaitingDays(startDate, serverTime);
    return _wd > 0 ? true : false;
  }

  public static isCompleted(endDate: any, serverTime: any) {
    let _wd = this.getWaitingDays(endDate, serverTime);
    return _wd < 0 ? true : false;
  }

  public static isToday(startDate: any, serverTime: any) {
    let now = moment(serverTime);
    let tma = moment(startDate).format('L') == now.format('L');
    return tma;
  }

  public static liveClassCounter(
    serverTime: any,
    startTime: any,
    endTime: any,
    _for: string = ''
  ): object {
    let joinTeacher: any;
    var servTime = moment.unix(serverTime);
    var isToday = this.isToday(moment.unix(startTime), servTime);
    // var isTomorrow = this.isTomorrow(moment.unix(endTime))
    let result: boolean = false;
    var sTime: any = '';

    if (_for == 'teacher') {
      sTime = moment.unix(startTime).subtract(30, 'minutes');
    } else {
      sTime = moment.unix(startTime);
    }

    var eTime = moment.unix(endTime);
    if (!isToday) {
      result = false;
    }

    if (
      sTime.format() < servTime.format() &&
      eTime.format() > servTime.format()
    ) {
      result = true;
    }

    var duration = moment.duration(sTime.diff(servTime));
    var diff = duration.asMilliseconds();
    var endDuration = moment.duration(eTime.diff(servTime));
    var enddiff = endDuration.asMilliseconds();
    if (diff < 0 && enddiff > 0) {
      result = true;
    }

    if (enddiff < 0) {
      result = false;
    }

    let liveat = setTimeout(() => {
      result = true;
    }, diff);

    let livetill = setTimeout(() => {
      clearTimeout(livetill);
      result = false;
    }, enddiff);

    if (_for == 'joinTeacher') {
      let st = moment.unix(startTime).subtract(30, 'minutes');
      let dur = moment.duration(st.diff(servTime));
      let sd = dur.asMilliseconds();
      joinTeacher = sd;
    }

    return { sdiff: diff, ediff: enddiff, result: result, joinTeacher };
  }

  public static getWaitingDays(startDate: any, serverTime: any) {
    let _now = moment(serverTime);
    let _given = moment(startDate);
    return Math.round(moment.duration(_given.diff(_now)).asDays());
  }

  public static isOnGoing = (_schedule: any = null) => {
    if (_schedule != undefined && Object.keys(_schedule).length > 0) {
      let _sDate = new Date(_schedule.startDate);
      let _eDate = new Date(_schedule.endDate);
      let _serverTime = new Date(_schedule.serverTime);
      return moment(_serverTime).isBetween(_sDate, _eDate);
    } else {
      return false;
    }
  };
}
